import axios from 'axios';

export const AttachChildApi = {
  loadRequests: filter => axios.get(`/api/public/child_connection_form?filter=${filter}`),
  makeApplication: formData => axios.post(`/api/public/child_connection_form`, formData),
  getSignature: formData =>
    axios.post(`/api/public/child_connection_form/sign_string/new_form`, formData)
};
